import type { DataAction } from '../../../types/dataAction.type';
import type { RedirectValue } from '../types';

export const UPDATE_QR_CODE_LINK_IOS = 'UPDATE_QR_CODE_LINK_IOS' as const;

export const updateQrCodeLinkIos = (ios: RedirectValue) => ({
  data: { ios },
  type: UPDATE_QR_CODE_LINK_IOS,
});

export type UpdateQrCodeLinkIosResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_IOS, { ios: RedirectValue }>;
